export const env = {
  AUTH_API_URL: process.env.REACT_APP_AUTH_API_URL || 'https://internal.podstack.ai/auth/',
  // gpustack gateway. NOTE the trailing path segment — the training endpoints
  // (/gpu-types, /pricing, /instances, /ssh-keys, /me) are appended to this.
  TRAINING_API_URL: process.env.REACT_APP_TRAINING_API_URL || 'https://cloud.podstack.ai/gpu/api/v1',
  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
  CUSTOMER_LOGIN_URL: process.env.REACT_APP_CUSTOMER_LOGIN_URL || 'https://cloud.podstack.ai/portal/login',
  // Absolute URL to the customer-portal wallet/top-up page (different subdomain,
  // so it MUST be absolute — a relative /wallet would stay on training.podstack.ai).
  WALLET_TOPUP_URL: process.env.REACT_APP_WALLET_TOPUP_URL || 'https://cloud.podstack.ai/portal/wallet',
  // platform-service base URL — hosts the wallet APIs (/wallet, /wallet/topup,
  // /wallet/transactions, /wallet/paypal/*). Includes the /api/v1 segment.
  PLATFORM_API_URL: process.env.REACT_APP_PLATFORM_API_URL || 'https://cloud.podstack.ai/platform/api/v1',
  // PayPal is opt-in. Both flags must be set for the PayPal top-up path to show;
  // if either is missing we render Razorpay only and never crash.
  PAYPAL_CLIENT_ID: process.env.REACT_APP_PAYPAL_CLIENT_ID || '',
  ENABLE_PAYPAL: process.env.REACT_APP_ENABLE_PAYPAL === 'true',
};
